/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const Patch1P3ProviderLTIDataParser = 
/* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['iss', /* #__PURE__ */ codecOptional(codecString)],
    ['clientId', /* #__PURE__ */ codecOptional(codecString), 'client_id'],
    ['authTokenUrl', /* #__PURE__ */ codecOptional(codecString), 'auth_token_url'],
    ['authLoginUrl', /* #__PURE__ */ codecOptional(codecString), 'auth_login_url'],
    ['keySetUrl', /* #__PURE__ */ codecOptional(codecString), 'key_set_url'],
    ['authAudience', /* #__PURE__ */ codecOptional(codecString), 'auth_audience'],
    ['finalize', /* #__PURE__ */ codecOptional(codecBoolean)],
]));
export class Patch1P3ProviderLTIData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Patch1P3ProviderLTIDataParser.decode(input).map(res => new Patch1P3ProviderLTIData(res));
    }
    static unsafeDecode(input) {
        return Patch1P3ProviderLTIData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Patch1P3ProviderLTIDataParser.encode(data);
    }
    static schema() {
        return Patch1P3ProviderLTIDataParser.schema();
    }
}
